<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName"></div>
  </div>
</template>

<script>
import {CHART_TYPE} from "@/option/common/dict";
import util from "@/option/common/util";
import {unref} from "vue";

export default {
  name: "helmetBar",
  methods: {
    handlerDimParam(param) {
      // 指标环图结构, 辅助指标显示在柱状图复用，通过assistTip字段加一层控制
      param.componentType = this.option.assistTip ? 'indexRingGraph' : undefined;
      return param
    },
    // 6位数的色值，转化成rgba，主要是为了设置渐变色的透明度
    hexColorToRGBA(hex, alpha) {
      const rgb = []; // 定义rgb数组
      if (/^\#[0-9A-F]{3}$/i.test(hex)) {
        // 判断传入是否为#三位十六进制数
        let sixHex = "#";
        hex.replace(/[0-9A-F]/gi, function (kw) {
          sixHex += kw + kw; // 把三位16进制数转化为六位
        });
        hex = sixHex; // 保存回hex
      }
      if (/^#[0-9A-F]{6}$/i.test(hex)) {
        // 判断传入是否为#六位十六进制数
        hex.replace(/[0-9A-F]{2}/gi, function (kw) {
          // eslint-disable-next-line no-eval
          rgb.push(eval("0x" + kw)); // 十六进制转化为十进制并存如数组
        });
        return `rgba(${rgb.join(",")},${alpha / 100})`; // 输出RGB格式颜色
      } else {
        return "rgb(0,0,0)";
      }
    },
    // 换行，双碳定死的如果所有指标都是4个字，换成2行，双碳业务，后续会优化成配置项
    isSplitToTWOLine(arr) {
      return arr.every((item) => item && item.length === 4);
    },
    // x轴的名称换行，双碳业务，后续会优化成配置项
    resetXName(data) {
      if (this.isSplitToTWOLine(data)) {
        return data.map((item) => {
          return item.slice(0, 2) + "\n" + item.slice(2);
        });
      } else {
        return data;
      }
    },
    updateChart() {
      const optionData = this.deepClone(this.dataChart);
      let option = {
        dataZoom: this.getDataZoom(),
        title: this.getOptionTitle(),
        tooltip: this.getOptionTip({
          trigger: "axis",
          confine: true
        }),
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(),
        xAxis: this.getXAxisOption({
          data: this.resetXName(optionData?.categories || []), // 换行
        }),
        yAxis: this.getYAxisOption({
          show: true, // this.validData(this.option.yAxisShow, true),
          data: optionData?.categories || [],
        }),
        series: (() => {
          const barColor = this.option.barColor || [];
          // 带帽柱状图的帽子样式处理代码
          const list = (optionData?.series || []).map((ele, index) => {
            const values = ele.data;
            const max = Math.max.apply(null, values);
            const min = Math.min.apply(null, values);
            // 实际使用场景中发现有些数据会有最大值的0.03比数据项的最小值还大的数据，做额外的数据处理
            const min_val = Math.abs(max * 0.03) > min ? Math.abs(min * 0.3) : Math.abs(max * 0.03);
            const defaultColor = !this.getColor(index).colorStops ? this.getColor(index) : this.getColor(index).colorStops[1].color;
            // color，取到的配置项或者默认颜色值
            const color = defaultColor.indexOf('rgba') >= 0 ? defaultColor : this.hexColorToRGBA(defaultColor, 100);
            // 根据默认色值设置需要渐变的完全透明色值
            const opacityColor = defaultColor.indexOf('rgba') >= 0 ? defaultColor.replace('1)', '0)') : this.hexColorToRGBA(defaultColor, 0);
            return Object.assign(ele, {
              type: "bar",
              stack: ele.stack,
              barWidth: this.option.barWidth || 16,
              barMinHeight: this.option.barMinHeight || 0,
              itemStyle: this.getHasProp(
                  !this.switchTheme,
                  {
                    // 颜色配置，参考echarts柱状图的渐变色配置
                    color: new window.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {offset: 0, color: color},
                      {
                        offset: Math.min(1, values[index] != 0 ? Math.abs(min_val / values[index]) : 0),
                        color: opacityColor,
                      },
                      {
                        offset: Math.min(1, values[index] != 0 ? Math.abs(min_val / values[index]) * 1.5 : 0),
                        color: color,
                      },
                      {offset: 1, color: opacityColor},
                    ]),
                  },
                  {barBorderRadius: this.option.barRadius || 0}
              ),
              label: this.getOptionLabel({
                position: this.option.category ? "right" : "top",
              }),
            });
          });
          return list;
        })(),
      };
      if (this.isDataCenter) {
        let _op = this.getDimentionOption();
        if (this.option.assistTip) {
          _op.series = _op.series.map(item => {
            return {
              ...item,
              data: item.data.map(dataItem => {
                return dataItem.value
              })
            }
          })
        } else {
          _op.series = _op.series.map(item => {
            return {
              ...item,
              data: item.data.map(dataItem => {
                const {code} = this.prop.metrics.find(metItem => metItem.fieldName === item.name)
                if (code && dataItem[code]) {
                  return dataItem[code]
                } else {
                  return dataItem
                }
              })
            }
          })
        }

        const {
          yAxisMarkLine = 0,
          yAxisMarkName = "",
          yAxisMarkValue = "",
        } = this.option;
        let markLineData = [];
        if (yAxisMarkLine) {
          const markLineNameArr = yAxisMarkName.split(",");
          const markLineValueArr = yAxisMarkValue.split(",");
          if (
              markLineNameArr.length === yAxisMarkLine &&
              markLineValueArr.length === yAxisMarkLine
          ) {
            markLineData = markLineNameArr.map((item, index) => {
              return {
                yAxis: markLineValueArr[index],
                name: item,
                lineStyle: {
                  color: this.getColor(index),
                  type: "dashed",
                },
                label: {
                  show: false,
                  color: "#ffffff",
                  fontSize: 10,
                  position: "insideStartTop",
                  formatter: function (param) {
                    return item + " : " + param.value;
                  },
                },
                emphasis: {
                  label: {
                    show: true,
                    color: "#ffffff",
                    fontSize: 12,
                    formatter: function (param) {
                      return item + " : " + param.value;
                    },
                  },
                },
              };
            });
          }
        }
        option.xAxis.data = this.resetXName(_op.categories);
        option.legend = this.getOptionLegend(_op.series);
        // 辅助指标显示到tooltip
        if (this.prop.assistMetrics && this.prop.assistMetrics.length && this.option.assistTip) {
          option.tooltip.formatter = (params) => util.assistMetricsToolFormatter(params, this.prop, this.dataChart, _op.series)
        }
        option.series = _op.series.map((el, index) => {
          const values = el.data;
          const max = Math.max.apply(null, values);
          const min = Math.min.apply(null, values);
          const min_val = Math.abs(max * 0.03) > min ? Math.abs(min * 0.3) : Math.abs(max * 0.03);
          const defaultColor = !this.getColor(index).colorStops ? this.getColor(index) : this.getColor(index).colorStops[0].color;
          const color = defaultColor.indexOf('rgba') >= 0 ? defaultColor : this.hexColorToRGBA(defaultColor, 100);
          const opacityColor = defaultColor.indexOf('rgba') >= 0 ? defaultColor.replace('1)', '0)') : this.hexColorToRGBA(defaultColor, 0);
          return {
            ...el,
            itemStyle: {
              color: defaultColor,
            },
            data: el.data.map((item) => {
              return {
                value: item * 1,
                itemStyle: this.getHasProp(
                    !this.switchTheme,
                    {
                      color: new window.echarts.graphic.LinearGradient(
                          0,
                          0,
                          0,
                          1,
                          [
                            {offset: 0, color: color},
                            {
                              offset: Math.min(1, item * 1 != 0 ? Math.abs(min_val / (item * 1)) : 0),
                              color: opacityColor,
                            },
                            {
                              offset: Math.min(1, item * 1 != 0 ? Math.abs(min_val / (item * 1)) * 1.5 : 0),
                              color: color,
                            },
                            {offset: 1, color: opacityColor},
                          ]
                      ),
                    },
                    {barBorderRadius: this.option.barRadius || 0}
                ),
              };
            }),
            type: "bar",
            stack: el.stack,
            barWidth: this.option.barWidth || 16,
            barMinHeight: this.option.barMinHeight || 0,
            label: this.getOptionLabel({
              position: this.option.category ? "right" : "top",
            }),
            markLine: {
              show: yAxisMarkLine && yAxisMarkLine > 0,
              symbol: "none",
              data: markLineData,
            },
          };
        });
      }
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    },
  },
};
</script>
